export default {
  Confirm: 'Onayla',
  Cancel: 'İndir',
  'The minimum time length is xxxs!': "Minimum süre uzunluğu {{num}}s'dir!",
  'The maximum time length is 50s!': 'Maksimum süre uzunluğu 50 saniyedir!',
  'Online service, no download required': 'Çevrimiçi hizmet, indirme gerekmez',
  'Add up to 20MB file': '20MB’ye kadar dosya ekleyin',
  'Support common formats': 'Ortak biçimleri destekler',
  'Best for general editing requirements': 'Genel düzenleme gereksinimleriniz için en iyisi',
  '0 second wait': '0 saniye bekleme',
  'No size limits': 'Boyut sınırı yok',
  'Support 1000+ formats': "1000'den fazla biçimi destekler",
  'Stable processing': 'Kararlı işleme',
  'Get access to HitPaw Toolkit!': "HitPaw Toolkit'e erişin!",
  'Support cut, crop & rotate, adjust, speed, add music, stop motion, etc.':
    'Kesme, kırpma ve döndürme, ayarlama, hızlandırma, müzik ekleme, hareketi durdurma vb. destekler',
  'The easiest video editing software for beginners':
    'Yeni başlayanlar için en kolay video düzenleme yazılımı',
  'Remove watermark from videos and images in simple clicks':
    'Basit tıklamalarla videolardan ve resimlerden filigranı kaldırın',
  'TRY IT FREE': 'ÜCRETSİZ DENEYİN',
  'BUY NOW': 'ŞİMDİ SATIN AL',
  'Analyzing successfully! Your file is larger than 100 MB which cannot be edited by HitPaw Online, please ':
    "Başarıyla analiz ediliyor! Dosyanız 100 MB'den büyük ve HitPaw Online tarafından düzenlenemiyor, lütfen ",
  'download the video': 'videoyu indirin ',
  'and then use HitPaw Toolkit to proceed.': "ve devam etmek için HitPaw Toolkit'i kullanı",
  'Cut 10 video fragments at most. Get HitPaw Toolkit for more features.':
    'En fazla 10 video parçasını kesin. Daha fazla özellik için HitPaw Toolkit alın.',
  'Max file size for videos is 20 MB. Get HitPaw Toolkit for big file.':
    "Dosya boyutu 20MB'den büyük olamaz. Daha fazla özellik için HitPaw Toolkit alın.",
  'The minimum time length is 1s! Get HitPaw Toolkit for more features.':
    "Minimum süre uzunluğu 1s'dir! Daha fazla özellik için HitPaw Toolkit alın.",
  'Add 3 videos at most. Get HitPaw Toolkit for more features.':
    'En fazla 3 video ekleyin. Daha fazla özellik için HitPaw Toolkit alın.',
  'This format is not supported currently.': 'Bu biçim şu anda desteklenmiyor.',
  'This format is not supported currently. Get HitPaw Toolkit for more formats':
    'Bu biçim şu anda desteklenmiyor. Daha fazla özellik için HitPaw Toolkit alın.',
  'Processing failed. Get HitPaw Toolkit for stable processing.': 'Video Oluşturulamadı!',
  'Failed to load!  Get HitPaw Watermark Remover for stable processing.': 'Yükleme başarısız!',
  'Are you sure you want to delete it?': 'Silmek istediğinizden emin misiniz?',
  'Failed to extract the audio!': 'Ses çıkarılamadı!',
  'Coming Soon': 'Çok yakında',
  'Learn more': 'Daha fazla bilgi edin',
  'Add up to 2 files. Get HitPaw Toolkit for big file.':
    'En fazla 2 dosya ekleyin. Daha fazla özellik için HitPaw Toolkit alın.',
  Download: 'İndir',
  'Try Again': 'Tekrar Deneyin',
  Failed: 'Başarısız',
  'Get Started': 'Başlamak',
  Start: 'Başlat',
  End: 'Sonlandır',
  Export: 'Dışa aktar',
  'Your audio is ready!': 'Sesiniz hazır!',
  'Download Audio': 'Ses İndir',
  YES: 'EVET',
  'Export Failed': 'Dışa Aktarma Başarısız',
  'Error occurs, the file cannot be added': 'Hata oluşuyor, dosya eklenemiyor',
  'Support merging audio files at most': 'En fazla {{num}} ses dosyasını birleştirme desteği',
  'Are you sure you want to delete this task?': 'Bu görevi silmek istediğinizden emin misiniz?',
  Processing: 'İşleniyor',
  "Don't forget to download your file, it will be deleted after 24 hours.":
    'Dosyanızı indirmeyi unutmayın, 24 saat sonra silinecektir.',
  Uploading: 'Yükleniyor',
  'Go Edit': 'Düzenleme gidin',
  'Generate Files Successfully!': 'Dosyaları Başarıyla Oluşturun!',
  'Your order is being paid...': 'Siparişinizin ödemesi yapılıyor',
  'Not yet': '',
  'Payment completed': 'Evet',
  downloadFail: 'Failed to download, please try again.',
  videoReady: 'Your animated photo is ready!',
  'Download Without Watermark': 'Download Without Watermark',
  'Download As GIF': 'Download As GIF',
  'Download With Watermark': 'Download With Watermark',
  'Upload New Photo': 'Upload New Photo',
  ///////////
  'Upgrade to access HitPaw Online Pro Features.': 'Upgrade to access HitPaw Online Pro Features.',
  'Free account cannot upload image size that exceeds 2M.':
    'Free account cannot upload image size that exceeds 2M.',
  'Free account cannot upload more than 6 images.':
    'Free account cannot upload more than 6 images.',
  'No Image Size Limits': 'No Image Size Limits',
  'Unlimited Image Uploads': 'Unlimited Image Uploads',
  'Download HD Image with No Watermark': 'Download HD Image with No Watermark',
  'Download Video as GIF': 'Download Video as GIF',
  'More Privileges': 'More Privileges',
  Monthly: 'Monthly',
  Yearly: 'Yearly',
  'Cancel auto-renewable subscription anytime.': 'Cancel auto-renewable subscription anytime.',
  'Login to Start': 'Login to Start',
  'Buy Now': 'Buy Now',
  'Network Error': 'Network Error',
  'Connection server failed.': 'Connection server failed.',
  Month: 'Month',
  priceMonth: '$9.99',
  priceYear: '$4.99',
  'HitPaw Video Converter': 'HitPaw Video Converter',
  'The upload video size cannot exceed 20MB. Download HitPaw Video Converter for more features.': 'The uploaded video size cannot exceed 20MB. Download HitPaw Video Converter for more features.',
  'The upload video size cannot exceed 500MB. Download HitPaw Video Converter for more features.': 'The uploaded video size cannot exceed 500MB. Download HitPaw Video Converter for more features.',
  'The upload image resolution cannot exceed 16 megapixel. Download HitPaw Video Converter for more features.':  'The uploaded image resolution cannot exceed 16 megapixel. Download HitPaw Video Converter for more features.',
  'The batch processing function is only available in the desktop software. Download HitPaw Video Converter for more features.': 'The batch processing function is only available in the desktop software. Download HitPaw Video Converter for more features.',
  'The number of files you processed today has reached the upper limit of 300. Download HitPaw Video Converter for more features.': 'The number of files you processed today has reached the upper limit of 300. Download HitPaw Video Converter for more features.',
  'Download desktop version to batch process large files with no size limit': 'Download desktop version to batch process large files with no size limit',
  'Batch convert video and audio files to 1000+ formats with 120X faster speed': 'Batch convert video and audio files to 1000+ formats with 120X faster speed',
  'Download and save videos from 10000+ websites, such as YouTube, TikTok, Instagram, etc.': 'Download and save videos from 10000+ websites, such as YouTube, TikTok, Instagram, etc.',
  'Built-in rich video editing features: merge, cut, crop, watermark, etc.': 'Built-in rich video editing features: merge, cut, crop, watermark, etc.',
  'Convert Apple Music to MP3 with DRM removed (Windows version only)': 'Convert Apple Music to MP3 with DRM removed (Windows version only)',
}
